/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */

import { Directive, Output, EventEmitter, ElementRef, OnInit, inject } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';

@Directive({
  selector: '[mouseHover]',
})
export class HoverDirective implements OnInit {
  private el = inject(ElementRef);

  private mouseEnter$: Observable<MouseEvent>;
  private mouseLeave$: Observable<MouseEvent>;

  @Output() hoverState: EventEmitter<string> = new EventEmitter<string>();

  ngOnInit(): void {
    this.mouseEnter$ = fromEvent(this.el.nativeElement, 'mouseenter');
    this.mouseLeave$ = fromEvent(this.el.nativeElement, 'mouseleave');

    this.mouseEnter$.subscribe(() => {
      this.hoverState.emit('active');
    });

    this.mouseLeave$.subscribe(() => {
      this.hoverState.emit('inactive');
    });
  }
}
